import {
  wordCount
} from 'common/filter/filter'

export default class HomeWork {
  constructor ({
    id,
    homeworkTitle = '',
    homeworkRequest = '',
    homeworkContent = '',
    fileUpload,
    autoRemark = 1,
    showLevel = 0,
    timeSetWay = 1,
    allowSyntaxCheck = 1,
    allowPostattach = 2,
    allowDraft = 2,
    allowCopy = 2,
    duplicate = 1,
    startTime = new Date(),
    peerReviewTime = '',
    endTime = '',
    isEndTime = '',
    lateShipment = 0,
    lateShipmentTime = '',
    grade = 100,
    groupCount = 4,
    growth = 3,
    peerReviewCount = 1,
    teacherId = '',
    selectClass = [],
    classNames,
    peerReviewHomeworkRuleList,
    hasStuSubmit,
    ocId = 0,
    gradePublish = 1
  }) {
    this.id = id || 0
    this.homeworkTitle = homeworkTitle
    this.homeworkRequest = homeworkRequest
    this.homeworkContent = homeworkContent
    let fileArr = []
    if (typeof (fileUpload) === 'string' && fileUpload.length !== 0) {
      fileArr = JSON.parse(fileUpload)
    }
    this.fileUpload = fileArr
    this.autoRemark = autoRemark || 1
    this.timeSetWay = timeSetWay || 1
    this.showLevel = showLevel || 0
    this.allowSyntaxCheck = allowSyntaxCheck
    this.allowPostattach = allowPostattach
    this.allowCopy = allowCopy
    this.allowDraft = allowDraft
    this.duplicate = duplicate
    this.startTime = startTime
    this.peerReviewCount = peerReviewCount
    this.peerReviewTime = peerReviewTime
    this.endTime = endTime
    this.isEndTime = isEndTime
    this.lateShipment = lateShipment
    this.lateShipmentTime = lateShipmentTime
    this.grade = grade
    this.groupCount = groupCount
    this.growth = growth
    this.teacherId = teacherId
    this.selectClass = selectClass
    this.homeworkType = 9
    this.classNames = classNames || []
    this.peerReviewHomeworkRuleList = peerReviewHomeworkRuleList
    this.ocId = ocId || 0
    this.hasStuSubmit = hasStuSubmit || 0
    this.gradePublish = gradePublish
  }

  // 获取选中班级的ID
  getSelectClassIDs () {
    return this.selectClass.map(function (item) {
      return item.classID
    })
  }

  getSaveModel () {
    let obj = Object.assign({}, this)
    delete obj.selectClass
    obj.classIDs = this.getSelectClassIDs()
    obj.homeworkClassList = this.selectClass
    obj.fileUpload = ''
    if (this.fileUpload.length !== 0) {
      obj.fileUpload = JSON.stringify(this.fileUpload)
    }
    return obj
  }

  // 获取时间的数组
  getTimeArr () {
    let arr = []
    arr.push(this.startTime)
    arr.push(this.endTime)
    arr.push(this.peerReviewTime)
    return arr
  }

  checkModel () {
    if (this.homeworkTitle.length === 0) {
      return '请输入作业题目'
    }
    if (wordCount(this.homeworkTitle) > 50) {
      return '标题不能超过50个字'
    }
    if (this.homeworkContent && wordCount(this.homeworkContent) > 5000) {
      return '作业内容不能超过5000字'
    }
    if (parseInt(this.autoRemark) === 4 && this.homeworkContent.length === 0) {
      return '请输入跟读内容'
    }
    if (this.grade < 0 || this.grade > 100) {
      return '请输入正确的满分'
    }
    if (!this.startTime && parseInt(this.timeSetWay) !== 2) {
      return '请输入作业开始时间'
    }
    if (!this.endTime && parseInt(this.timeSetWay) !== 2) {
      //        检查作业截止提交时间
      return '请输入作业截止时间'
    }
    if (this.autoRemark === '2') {
      // 1、检查每个学生评论的分数是否正确
      //        2、检查 互评截止时间
      if (!this.peerReviewTime && parseInt(this.timeSetWay) !== 2) {
        return '请输入互评截止时间'
      }
    }
    if (parseInt(this.timeSetWay) === 2 && this.selectClass) {
      const _this = this
      let msg = ''
      _this.selectClass.forEach(function (eachClass) {
        if (msg.length === 0) {
          if (!eachClass.startTime || eachClass.startTime === '') {
            msg = '请输入作业开始时间'
          } else if (!eachClass.endTime || eachClass.endTime === '') {
            msg = '请输入作业截止时间'
          } else if (parseInt(_this.autoRemark) === 2 && (!eachClass.peerReviewTime || eachClass.peerReviewTime === '')) {
            msg = '请输入互评截止时间'
          }
        }
      })
      if (msg.length !== 0) {
        return msg
      }
    }
    if (parseInt(this.autoRemark) === 4) {
      //          检查跟读内容 200字以内，英语
      if (wordCount(this.homeworkContent.length) > 200) {
        return '跟读内容不能超过200单词'
      }
    }
    if (this.selectClass.length === 0) {
      //          alert('请选择班级')
      return '至少选择一个班级'
    }
    return null
  }
}

let model = {}

export function createHomeWork (workData) {
  if (JSON.stringify(model) === '{}') {
    model = new HomeWork({
      id: workData.id,
      homeworkTitle: workData.homeworkTitle,
      homeworkRequest: workData.homeworkRequest,
      homeworkContent: workData.homeworkContent,
      fileUpload: workData.fileUpload,
      autoRemark: workData.autoRemark,
      allowSyntaxCheck: workData.allowSyntaxCheck,
      allowPostattach: workData.allowPostattach,
      allowCopy: workData.allowCopy,
      allowDraft: workData.allowDraft,
      duplicate: workData.duplicate,
      timeSetWay: workData.timeSetWay,
      showLevel: workData.showLevel,
      startTime: workData.startTime,
      peerReviewCount: workData.peerReviewCount,
      peerReviewTime: workData.peerReviewTime,
      endTime: workData.endTime,
      lateShipment: workData.lateShipment,
      lateShipmentTime: workData.lateShipmentTime,
      grade: workData.grade,
      groupCount: workData.groupCount,
      growth: workData.growth,
      teacherId: workData.teacherId,
      ocId: workData.ocId,
      hasStuSubmit: workData.hasStuSubmit,
      gradePublish: workData.gradePublish
    })
  }
  return model
}



// WEBPACK FOOTER //
// ./src/module/homework/model/homework.js